var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 36.3437V18C12.5 17.337 12.7634 16.7011 13.2322 16.2322C13.7011 15.7634 14.337 15.5 15 15.5H65C65.663 15.5 66.2989 15.7634 66.7678 16.2322C67.2366 16.7011 67.5 17.337 67.5 18V36.3437C67.5 62.5937 45.2188 71.2812 40.7813 72.75C40.2771 72.9366 39.7229 72.9366 39.2188 72.75C34.7813 71.2812 12.5 62.5937 12.5 36.3437Z",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 33L35.4063 50.5L26.25 41.75",
    stroke: "#FCFCFC",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.05c183441ec3864e9d6c311c38d7a8c3.svg";
export { ForwardRef as ReactComponent };